import { useState, useEffect } from 'react';
import { ensureMediaPermissions } from '../../../../utils';
import { isHandledMediaAccessError } from '../../../../utils/mediaAccessErrors';

export function useDevices() {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);

  useEffect(() => {
    const getDevices = async () => {
      try {
        await ensureMediaPermissions();
        setDevices(await navigator.mediaDevices.enumerateDevices());
      } catch (error) {
        if (isHandledMediaAccessError(error)) {
          setDevices([]);
          return;
        }

        console.error('Failed to enumerate media devices.', error);
      }
    };
    navigator.mediaDevices.addEventListener('devicechange', getDevices);
    void getDevices();

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', getDevices);
    };
  }, []);

  return devices;
}

export function useAudioInputDevices() {
  const devices = useDevices();
  return devices.filter(device => device.kind === 'audioinput');
}

export function useVideoInputDevices() {
  const devices = useDevices();
  return devices.filter(device => device.kind === 'videoinput');
}

export function useAudioOutputDevices() {
  const devices = useDevices();
  return devices.filter(device => device.kind === 'audiooutput');
}
